"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendBeaconToDWVideo = exports.sendBeaconFactory = void 0;
const env_1 = require("../env");
const logger_1 = __importStar(require("./utils/logger"));
const BEACON_BASE_PATH = 'https://beacon.wikia-services.com/';
function sendBeacon(path, trackData) {
    if (!(0, env_1.isOnBrowser)()) {
        return {};
    }
    try {
        let beaconURL = BEACON_BASE_PATH + path + '?';
        if (path.includes('http://') || path.includes('https://')) {
            beaconURL = path;
        }
        (0, logger_1.logWithQueryParamVerbose)('Sending beacon event to ' + beaconURL);
        // For base tracking events convert category,label,action with prefix 'ga'
        if (beaconURL === BEACON_BASE_PATH + '__track/special/trackingevent?') {
            try {
                if (trackData.label) {
                    trackData.ga_label = trackData.label;
                }
                if (trackData.category) {
                    trackData.ga_category = trackData.category;
                }
                if (trackData.value) {
                    trackData.ga_value = trackData.value;
                }
                if (trackData.action) {
                    trackData.ga_action = trackData.action;
                }
                // These values are no used at all for DW
                try {
                    delete trackData.label;
                    delete trackData.category;
                    delete trackData.action;
                    delete trackData.value;
                }
                catch (e) {
                    // ignore failures on the deletion process
                }
            }
            catch (e) {
                console.error('[Tracking - Send Beacon] Failure to convert with ga prefix');
            }
        }
        const query = new URLSearchParams();
        const keyValues = Object.entries(trackData);
        keyValues.forEach((pairs) => {
            query.append(pairs[0], pairs[1]);
        });
        if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
            (0, logger_1.logWithQueryParamVerbose)(beaconURL + query.toString());
            navigator.sendBeacon(beaconURL + query.toString());
        }
        else {
            (0, logger_1.default)('sendBeacon not available, fallback to fetch.');
            fetch(beaconURL + query.toString()).catch(console.error);
        }
    }
    catch (e) {
        console.error('Error sending beacon event', e);
    }
    return trackData;
}
exports.default = sendBeacon;
/**
 * Creates a function that can send DW data to a specific endpoint
 * @param path
 */
function sendBeaconFactory(path) {
    return (trackData) => {
        return sendBeacon(path, trackData);
    };
}
exports.sendBeaconFactory = sendBeaconFactory;
/**
 * Send Data to the special video endpoint
 * @param trackData
 */
function sendBeaconToDWVideo(trackData) {
    return sendBeacon('__track/special/video', trackData);
}
exports.sendBeaconToDWVideo = sendBeaconToDWVideo;
